export default {
  namespaced: false,
  state: () => {
    return {
      accountId: localStorage.getItem("accountId") || "", //用户id
      token: localStorage.getItem("token") || "",
      identityType: localStorage.getItem("identityType") || "",
      isGetUserToken: localStorage.getItem("isGetUserToken") || "0", //是否在获取token
      logintime: localStorage.getItem("logintime") || "", //登录的时间戳
      isSensorsInit: "", //神策是否初始化过
      userInfo: localStorage.getItem("userInfo") || "", //用户信息
      uuid: localStorage.getItem("uuid") || "",
      partner: localStorage.getItem("partner") || "", //来源，埋点用
      partnerH5: localStorage.getItem("partnerH5") || "", //来源，埋点用
      userType: localStorage.getItem("userType") || "", //用户类型
      WXShareId: localStorage.getItem("WXShareId") || "", // 埋点，小程序分享id
      // *******************下面都是字典**************
      client_id: "000011", //vapi接口的配置
      device: "pc", // 设备环境 wechat (小程序)、androidApp、android、iosApp、ios、pc
      appType: "", // app的类型 xy、job、yjs、weixin
      platform: "", // 设备平台 51jobApp、51jobM、51jobPC、yjsApp、yjsM、yjsPC
      fromdomain: localStorage.getItem("fromdomain") || "", // 51job_m、51job_pc、yjs_h5、yjs_web
      is51host: false,
      intention: {},
      currentAreaCode: "",
      subscribed: "", // 是否开启订阅通知
      wechatFollow:'', // 是否开启微信通知
      areaName: "",
      jobQuestionSets: localStorage.getItem("jobQuestionSets") || "",
      creatorInfo: localStorage.getItem("creatorInfo") || "",
      shareConfig: localStorage.getItem("shareConfig") || "",
      applyJobRefreshTasks: 0, //投递后刷新用户激励任务列表
      deweightComponentSort:0,//需要职位去重组件的加载顺序值
      bigWheelCountRefresh:false,
      nearbyPopShow:false,
      lon: '',
      lat: '',
      radius: '',
      hasPopupVisible: false, // 是否有弹窗正在显示
      countJobAndCompany: 1000, // 处理：如果活动页只有职位或公司楼层且无数据时，显示无职位引导

    };
  },

  getters: {
    userInfo(state) {
      return state.userInfo ? JSON.parse(state.userInfo) : {};
    },
    platform: (state) => state.platform,
    device: (state) => state.device,
    appType: (state) => state.appType,
    fromdomain: (state) => {
      const platform = state.platform;
      const fromdomain = state.fromdomain;
      if (["51jobApp", "yjsApp"].includes(platform)) {
        return fromdomain;
      } else if (["51jobM"].includes(platform)) {
        return "51job_m";
      } else if (["51jobPC"].includes(platform)) {
        return "51job_web";
      } else if (["51jobWX"].includes(platform)) {
        return "51job_weixin_wxapp";
      } else if (["yjsPC"].includes(platform)) {
        return "yjs_web";
      } else if (["yjsM"].includes(platform)) {
        return "yjs_h5";
      } else if (["yjsWX"].includes(platform)) {
        return "yjs_wxapp";
      } else {
        return "";
      }
    },
    webId: (state) => {
      const platform = state.platform;
      if (platform.includes("yjs")) {
        return 6;
      } else {
        return 2;
      }
    },
    isApp: (state) => ["androidApp", "iosApp"].includes(state.device),
    fromType: (state) => (state.platform.includes("51job") ? "51job" : "yjs"),
    isLogin: (state) => {
      return !!state.accountId;
    },
    currentAreaCode: (state) => {
      return state.currentAreaCode;
    },
    subscribed: (state) => {
      return state.subscribed;
    },
    wechatFollow: (state) => {
      return state.wechatFollow;
    },
    areaName: (state) => {
      return state.areaName;
    },
    intention: (state) => {
      return state.intention;
    },
    personAsLabelModify: (state) => {
      let result = 0;
      if (state.identityType) {
        result = state.identityType == "在校生" ? 2 : 1;
      }
      return result;
    },
    countJobAndCompany: (state) => state.countJobAndCompany,
  },

  mutations: {
    //给不同字段赋值
    setValueLocalStorage(state, param) {
      let keys = Object.getOwnPropertyNames(param);
      keys.forEach((item) => {
        let v =
          typeof param[item] == "object"
            ? JSON.stringify(param[item])
            : param[item];
        state[item] = v;
        localStorage.setItem(item, v);
      });
    },
    //给不同字段赋值,不缓存
    setValue(state, param) {
      let keys = Object.getOwnPropertyNames(param);
      keys.forEach((item) => {
        state[item] = param[item];
      });
    },
    setIntention(state, data) {
      state.intention = data;
      state.currentAreaCode = data.expectArea;
    },
    setCurrentAreaCode(state, code) {
      state.currentAreaCode = code;
    },
    setSubscribed(state, code) {
      state.subscribed = code;
    },
    setWechatFollow(state, code) {
      state.wechatFollow = code;
    },
    /**
     * v0402： 如果页面已经存在弹窗,不再弹出弹窗,防止同一时间内显示多个弹窗
     * @param {*} state 
     * @param {*} isVisible 
     */
    setPopupVisible(state, isVisible) {
      state.hasPopupVisible = isVisible;
    },
    subCountJobAndCompany(state) {
      state.countJobAndCompany--
    },
  },

  actions: {},
};
